export default "__VITE_PUBLIC_ASSET__5a9e0956__"